import httpClient from "@lab/api/httpClient";
import { UserDetails, UserLogin } from "@lab/types/users";

export const currentUser = {
	login: async (details: UserLogin): Promise<UserDetails | undefined> => {
		const response = await httpClient.post(`/auth/login/admin`, details);
		return response.data as UserDetails;
	},
	details: async () => {
		const response = await httpClient.get(`/users/details`);
		return response.data;
	}
};
